const STORAGE_KEY = 'swiftx_portal_language';

export const getStoredLanguage = (): string | null => {
    return localStorage.getItem(STORAGE_KEY);
};

export const setStoredLanguage = (language: string): void => {
    localStorage.setItem(STORAGE_KEY, language);
};

export const clearStoredLanguage = (): void => {
    localStorage.removeItem(STORAGE_KEY);
};
